'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoRepoPull = function GoRepoPull(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm40 12.5l-7.5-7.5v5h-15v5h15v5l7.5-7.5z m-12.5 12.5h-20v-22.5h20v5h2.5v-5s-1.2-2.5-2.5-2.5h-25s-2.5 1.3-2.5 2.5v30s1.3 2.5 2.5 2.5h5v5l3.8-3.7 3.7 3.7v-5h12.5s2.5-1.2 2.5-2.5v-15h-2.5v7.5z m0 6.3c0 0.5-0.6 1.2-1.2 1.2h-11.3v-2.5h-7.5v2.5h-3.7s-1.3-0.6-1.3-1.2v-3.8h25v3.8z m-15-21.3h-2.5v2.5h2.5v-2.5z m0-5h-2.5v2.5h2.5v-2.5z m0 10h-2.5v2.5h2.5v-2.5z m-2.5 7.5h2.5v-2.5h-2.5v2.5z' })
        )
    );
};

exports.default = GoRepoPull;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/repo-pull.js
// module id = 1979
// module chunks = 0